module.exports = __webpack_public_path__ + "img/2_Dicks_Screen_L_3_L.8b3ed7c3.jpg";